// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const curvePoint = {
  frequencySep: '',
  curvePoint: '',
}

// 15 blank curve points, the default set for an empty curve type
// this will be used when dealing with modulation details.
export const curveSet = Array.from({ length: 15 }, () => curvePoint)

export const emptyRadioCurveSet = {
  filterReferenceCode: '',
  radioCurveSetId: null,
  radioCurvePoints: [],
}

export const initialModulationValues = {
  bandwidth: '',
  coChannelTToI: '',
  dispersiveFm: '',
  downThreshold: '',
  emissionDesignator: '',
  filterReferenceCode: '',
  index: 'New',
  legacyRadioCode: '',
  maxAtpcTrigger: '',
  maxRxSignalDbm: '',
  maxSignatureDepth: '',
  minAtpcTrigger: '',
  minDelay: '',
  minSignatureDepth: '',
  modelNumber: '',
  modulationDescription: '',
  modulationSchemeId: '',
  nonMinDelay: '',
  radioCurveSet: emptyRadioCurveSet,
  radioModulationId: null,
  receiverNoiseFigure: '',
  rxThreshold: '',
  throughput: '',
  txPowerMax: '',
  upThreshold: '',
  xpif: '',
}
